import styles from './FormError.module.css';
const FormError = (props) => {
    return (<div class={styles.error}>{props.children}</div>);
};
export default FormError;
